import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'
import { isEqual } from 'lodash'
// @ts-ignore
import Toastify from 'toastify-js'
import 'toastify-js/src/toastify.css'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { useIntl } from 'react-intl'
import { serialize } from 'object-to-formdata'
import { write, utils } from 'xlsx'
import moment from 'moment'
import { RootState } from '../../setup'
import { getRequest } from '../../setup/redux/common/cruds'
import store from '../../setup/redux/Store'
import { ID, KTSVG } from '../../_metronic/helpers'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons'

const isMobile = window.innerWidth <= 768

export function CheckAccess(module: any) {
  const accesses = useSelector<RootState>(({ auth }) => auth.accesses, shallowEqual)
  if (accesses) {
    // @ts-ignore
    return accesses.includes(module)
  }
  return false
}

export function CheckModulesAccess(modules: string[]) {
  const accesses = useSelector<RootState>(({ auth }) => auth.accesses, shallowEqual)
  if (accesses) {
    // @ts-ignore
    return accesses.some((ai) => modules.includes(ai))
  }
  return false
}

export function IsRootUserOrAdmin() {
  const user: any = useSelector<RootState>(({ auth }) => auth.user, shallowEqual)
  return user?.is_root
}

export const IsCompanyAdmin = () => {
  const { user, active_inspection_company }: any = useSelector<RootState>(
    (state) => ({
      user: state.auth.user,
      active_inspection_company: state.auth.active_inspection_company,
    }),
    shallowEqual
  )
  if (!user.is_root) {
    return active_inspection_company?.groups.find((group: any) => group.slug === 'company-admins')
  }
  return false
}

export const handleNotificationPrompt = (
  title: any,
  message: any,
  icon: any,
  history: any,
  redirect_to: any = ''
) => {
  Swal.fire({
    title: title,
    html: message,
    icon: icon,
    allowOutsideClick: false,
  }).then(() => {
    Swal.close()
    if (redirect_to !== '') {
      history.push(redirect_to)
    }
  })
}

export const handleNotificationWithToastify = (
  data: any,
  history: any = null,
  redirect_to: any = ''
) => {
  Toastify({
    text: data.message,
    duration: 3000,
    newWindow: true,
    gravity: 'top',
    position: 'right',
    className: data?.success ? 'toastify-info' : 'toastify-error',
    stopOnFocus: true,
    onClick: function () {
      if (redirect_to !== '') {
        history.push(redirect_to)
      }
    },
  }).showToast()
}

export const SYSTEM_MODULES = {
  navigation: {
    // administrative_links: {
    //   group: ['groups.index', 'groups.create', 'groups.show', 'groups.edit'],
    //   configuration: ['configurations.index'],
    //   plans_management: [
    //     'plans_management.index',
    //     'plans/plans_management.create',
    //     'plans/plans_management.show',
    //     'plans/plans_management.edit',
    //     'plans/plans_management.delete',
    //   ],
    //   enterprise_requests: ['enterprise_plan.index'],
    //   Activity_company: [
    //     'inspection_companies.index',
    //     'inspection_companies.show',
    //     'inspection_companies.edit',
    //     'inspection_companies.delete',
    //   ],
    //   notification_template: ['events.index', 'events.show', 'events.edit'],
    // },
    masters: {
      team_management: [
        'team_management.index',
        'team_management.create',
        'team_management.show',
        'team_management.edit',
        'team_management.delete',
      ],
      project: [
        'projects.index',
        'projects.create',
        'projects.show',
        'projects.edit',
        'projects.delete',
      ],
      site: ['sites.index', 'sites.create', 'sites.show', 'sites.edit', 'sites.delete'],
      asset: ['assets.index', 'assets.create', 'assets.show', 'assets.edit', 'assets.delete'],
      HandS_Activity: ['inspection_listing.index'],
      asset_frequency: [
        'frequencies.index',
        'frequencies.create',
        'frequencies.show',
        'frequencies.edit',
        'frequencies.delete',
      ],
      Activity_templates: [
        'inspection_templates.index',
        'inspection_templates.create',
        'inspection_templates.show',
        'inspection_templates.edit',
        'inspection_templates.delete',
      ],
      calendar: ['calendar.index'],
      order: ['orders.index', 'orders.create', 'orders.show', 'orders.delete'],
      QR_code_mapping: ['mappings.index'],
      subscription_history: ['subscription_history.index', 'subscription_history.show'],
      transaction: ['transaction.index', 'transaction.show'],
    },
  },
}

export function BackButton() {
  const navigate = useNavigate()
  return (
    <button
      className='btn back-button'
      type='button'
      onClick={() => {
        navigate(-1)
      }}
    >
      Cancel
    </button>
  )
}

export function BackButtonForDetailPage({ path = '' }) {
  const navigate = useNavigate()
  return (
    <button
      className='btn btn-outline-secondary'
      type='button'
      onClick={() => {
        path ? navigate(path) : navigate(-1)
      }}
    >
      Back
    </button>
  )
}

export function PurposeForm({ type }: any) {
  const intl = useIntl()
  return (
    <div className='col-md-4'>
      <div className='card gutter-b'>
        <div className='card-body'>
          <p className='font-weight-bolder text-uppercase mb-10'>
            {intl.formatMessage({ id: `PURPOSE.${type}.TITLE` })}
          </p>
          <p>{intl.formatMessage({ id: `PURPOSE.${type}.DESCRIPTION` })}</p>
        </div>
      </div>
    </div>
  )
}

export function SubmitForm({
  handleSubmit,
  values,
  disabled,
  showDraftButton,
  handleDraft,
  isCreatePage,
}: any) {
  return (
    <div className='card gutter-b'>
      <div className='card-body pb-0'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='form-group d-flex justify-content-between'>
              <div>
                <BackButton />
              </div>
              <div>
                {showDraftButton && (
                  <button
                    type='button'
                    name='draft'
                    disabled={disabled}
                    className='btn btn-secondary me-5'
                    onClick={handleDraft}
                  >
                    Save as draft and exit
                  </button>
                )}
                <button
                  type='submit'
                  name='submit'
                  disabled={disabled}
                  className='btn btn-primary me-2'
                  onSubmit={() => handleSubmit()}
                >
                  {isCreatePage || !values.id ? 'Create' : 'Update'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const logoutPopup = (navigate: any) => {
  Swal.fire({
    icon: 'warning',
    title: 'Are you sure?',
    text: `You're about to leave Decent H&S. Continue?`,
    showCancelButton: true,
    confirmButtonText: 'Confirm',
    confirmButtonColor: '#061bb0',
    cancelButtonText: 'Cancel',
    reverseButtons: true,
    allowOutsideClick: false,
  }).then((result: any) => {
    if (result.isConfirmed) {
      navigate('/logout')
    }
  })
}

export const checkEmpty = (value: string) => {
  return value ? value : '-'
}

export const serializeValueWithArray = (values: any) => {
  const options = {
    indices: true,
    nullsAsUndefineds: false,
    booleansAsIntegers: false,
    allowEmptyArrays: true,
  }
  return serialize(values, options)
}

export const AuthFooter = () => (
  <>
    <div
      id='footer-links'
      className='d-flex align-items-center mt-5 mb-3 gap-1 signUpLink auth-footer'
    >
      <a
        className='link-primary fs-6'
        href='https://decenthands.com/terms-of-service'
        target='_blank'
        rel='noopener noreferrer'
      >
        Terms & Conditions
      </a>
      <a
        className='link-primary fs-6'
        href='https://decenthands.com/privacy-policy'
        target='_blank'
        rel='noopener noreferrer'
      >
        Privacy Policy
      </a>
      <a
        className='link-primary fs-6'
        href='https://decenthands.com/cookies-policy'
        target='_blank'
        rel='noopener noreferrer'
      >
        Cookie Policy
      </a>
      <a
        className='link-primary fs-6'
        href='https://decenthands.com/help-center'
        target='_blank'
        rel='noopener noreferrer'
      >
        Help
      </a>
    </div>
    <p className='hide_on_mobile'>
      <span className='text-dark'>
        Copyright &copy; {new Date().getFullYear()}
        &nbsp; Decent H&S Consultancy Ltd. All rights reserved.
      </span>
    </p>
  </>
)

export const getInitials = (name: any) => {
  name = !!name ? name.split(' ') : ['Amigo', 'Amigo']
  if (name.length > 2) {
    name = [name[0], name[name.length - 1]]
  }
  return name.length > 1
    ? name[0].substring(0, 1).toUpperCase()
    : name[0].substring(0, 1).toUpperCase()
}

export const maskEmail = (email: string) => {
  const [username, domain] = email.split('@')
  if (username && domain) {
    const maskedUsername = username.substring(0, 2) + '*'.repeat(username.length - 2)
    return maskedUsername + '@' + domain
  }
  return ''
}

export const maskPhoneNumber = (phoneNumber: string, countryCode: string) => {
  const visibleDigits = 2
  const hiddenDigits = Math.max(phoneNumber.length - (visibleDigits + 4), 0)

  const maskedNumber = `+${countryCode} ${phoneNumber.substring(0, visibleDigits)}${'*'.repeat(hiddenDigits)}${phoneNumber.slice(-4)}`
  return maskedNumber
}

export const maskMobileNumber = (
  phoneNumber: string,
  countryCode: string,
  visibleDigits = 2,
  lastVisibleDigit = 2
) => {
  const hiddenDigits = Math.max(phoneNumber.length - (visibleDigits + lastVisibleDigit), 0)

  const maskedNumber = `+${countryCode} ${phoneNumber.substring(0, visibleDigits)}${'X'.repeat(hiddenDigits)}${phoneNumber.slice(-lastVisibleDigit)}`
  return maskedNumber
}

//added for export csv
export function fitToColumn(arrayOfArray: any[]) {
  // get maximum character of each column
  return arrayOfArray[0].map((a: any, i: number) => ({
    wch: Math.max(...arrayOfArray.map((a2) => (a2[i] ? a2[i].toString().length + 5 : 0))),
  }))
}

export const downloadExcel = (data: any[], name: string) => {
  const sheet = utils.aoa_to_sheet(data)
  sheet['!cols'] = fitToColumn(data)

  // Create a new workbook
  const workbook = {
    SheetNames: ['Sheet1'],
    Sheets: {
      Sheet1: sheet,
    },
  }

  // Convert the workbook to an XLSX file
  const excelBuffer = write(workbook, { bookType: 'xlsx', type: 'buffer' })

  // Create a Blob from the buffer
  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  // Create a download link and trigger the download
  const downloadLink = document.createElement('a')
  downloadLink.href = URL.createObjectURL(blob)
  downloadLink.download = name
  downloadLink.click()
}

export const compareTwoObj = (obj1: any, obj2: any): boolean => {
  return isEqual(obj1, obj2)
}

export function replaceDashesWithUnderscores(input: string): string {
  return input.replace(/-/g, '_')
}

export const formatSecondTime = (time: number) => {
  return time < 10 ? `0${time}` : time.toString()
}

export const formattedPhoneNumber = (country_code: string, phone: string) => {
  return `+${country_code}${phone}`
}

export const validateEmail = (email: string) => {
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/
  if (!email) {
    return true
  } else if (!emailRegex.test(email)) {
    return true
  } else if (email.length < 3) {
    return true
  } else if (email.length > 50) {
    return true
  }
  return false
}

export const resetLocalStorageData = () => {
  localStorage.setItem('otpRemainingTime', '60')
  localStorage.setItem('otpResendCount', '0')
  localStorage.setItem('otpMaxResendCount', '3')
}

export function isObjectEmpty(obj: any) {
  return Object.keys(obj).length === 0
}

export const encryptPassword = (password: any) => {
  return btoa(password)
}

export const decryptPassword = (encodedPassword: any) => {
  return atob(encodedPassword)
}

export function sortByProperty<T extends { [key: string]: any }>(array: T[], property: string): T[] {
  return array.slice().sort((a, b) => a[property] - b[property])
}

export function removeDuplicates<T>(array: T[]): T[] {
  return [...new Set(array)]
}

export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function convertUTCToLocal(utcDate: string | Date, format: string | null = null) {
  const momentObject = moment(utcDate).local()

  if (format) {
    return momentObject.format(format)
  }

  return momentObject.format()
}

export function convertLocalToUTC(localDate: string | Date, format: string | null = null) {
  const momentObject = moment(localDate).utc()

  if (format) {
    return momentObject.format(format)
  }

  return momentObject.format()
}

export function transformFrequencyForEdit(frequency: any) {
  if (!frequency || !frequency.start_time_utc || !frequency.end_time_utc) {
    return frequency
  }

  const transformed = { ...frequency }

  if (frequency?.user?.id) {
    transformed.user_id = frequency.user.id
  }

  const startTimeLocal = convertUTCToLocal(frequency.start_time_utc)
  transformed.start_date = moment(startTimeLocal).format('YYYY-MM-DD')
  transformed.start_time = moment(startTimeLocal).format('HH:mm')

  const endTimeLocal = convertUTCToLocal(frequency.end_time_utc)
  transformed.end_date = moment(endTimeLocal).format('YYYY-MM-DD')
  transformed.end_time = moment(endTimeLocal).format('HH:mm')

  return transformed
}

export const handleViewInvoice = async (invoice: string | null) => {
  const errorMsg = {
    message: 'Something went wrong',
    success: false,
  }

  try {
    const response = await getRequest(
      `${process.env.REACT_APP_API_BASE_URL}stripe/invoice/${invoice}/url`
    )
    if (response.data.success) {
      return window.open(response.data.url, '_blank')
    } else {
      return handleNotificationWithToastify(response.data)
    }
  } catch {
    return handleNotificationWithToastify(errorMsg)
  }
}

export const renderDayHeader = (arg: any) => {
  const firstLetter = arg.date.toLocaleDateString('en-US', { weekday: 'short' }).charAt(0)

  switch (arg.view.type) {
    case 'dayGridMonth':
      if (isMobile) {
        return <div>{firstLetter}</div>
      }
      return arg.date.toLocaleDateString('en-US', { weekday: 'short' })
    case 'timeGridWeek':
      if (isMobile) {
        return (
          <div>
            <span>{firstLetter}</span>
            <br />
            <span className='font-weight-bold fs-sm-4 fs-6'>{arg.date.getDate()}</span>
          </div>
        )
      }
      return (
        <div>
          <span>{arg.date.toLocaleDateString('en-US', { weekday: 'short' })}</span>
          <br />
          <span className='font-weight-bold fs-4'>{arg.date.getDate()}</span>
        </div>
      )

    default:
      return arg.date.toLocaleDateString('en-US', { weekday: 'short' })
  }
}

export const getSortIcon = (
  isSorted: boolean,
  isSortedDesc: any,
  isDefaultSortedColumn: boolean,
  defaultSortOrder: any
) => {
  if (isSorted || isDefaultSortedColumn) {
    const order = isSorted ? isSortedDesc : defaultSortOrder === 'desc'
    return order ? (
      <FontAwesomeIcon icon={faArrowDown} className='sort-icon' />
    ) : (
      <FontAwesomeIcon icon={faArrowUp} className='sort-icon' />
    )
  } else {
    return <KTSVG className='opacity-0-6' path='/media/icons/duotune/arrows/up-down.svg' />
  }
}

export function updateAdhocFrequencies(frequencies: any) {
  return frequencies
    .filter((item: any) => item.start_time_utc && item.end_time_utc)
    .flatMap((item: any, index: any) => {
      const isOneTimeInspection = item.frequency.inspection_type === 'one-time'

      if (!isOneTimeInspection) {
        const start_date_local = convertUTCToLocal(item.start_time_utc)
        const end_date_local = convertUTCToLocal(item.end_time_utc)
        const startDate = new Date(start_date_local)
        const endDate = new Date(end_date_local)

        // item.start_time.split(':').forEach((time: any, index: number) => {
        //   if (index === 0) startDate.setHours(time)
        //   if (index === 1) startDate.setMinutes(time)
        //   if (index === 2) startDate.setSeconds(time)
        // })

        // item.end_time.split(':').forEach((time: any, index: number) => {
        //   if (index === 0) endDate.setHours(time)
        //   if (index === 1) endDate.setMinutes(time)
        //   if (index === 2) endDate.setSeconds(time)
        // })

        return [
          {
            ...item,
            itemId: item.id,
            id: `${item.id} - ${index}`,
            start: startDate,
            end: endDate,
            title: item.frequency.name,
            description: item.frequency.description,
          },
        ]
      }

      const results: any = []
      const one_time_freq_start_date_local = convertUTCToLocal(item.frequency.start_time_utc)
      const one_time_freq_end_date_local = convertUTCToLocal(item.end_time_utc)
      const start_date = new Date(one_time_freq_start_date_local)
      const end_date = new Date(one_time_freq_end_date_local)

      const start = moment(start_date)
      const end = moment(end_date)

      let subIndex = 1

      for (let current = start.clone(); current.isSameOrBefore(end); current.add(1, 'day')) {
        const startDate = current.clone().set({
          hour: start.hour(),
          minute: start.minute(),
          second: start.second(),
        })

        const endDate = current.clone().set({
          hour: end.hour(),
          minute: end.minute(),
          second: end.second(),
        })

        results.push({
          ...item,
          itemId: item.id,
          id: `${item.id} - ${index} - ${subIndex}`,
          start: startDate.toDate(),
          end: endDate.toDate(),
          title: item.frequency.name,
          description: item.frequency.description,
        })

        subIndex++
      }

      return results
    })
}

export const stripHTMLTags = (html: any) => {
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = html
  const removeEmptyElements = (node: any) => {
    const treeWalker = document.createTreeWalker(node, NodeFilter.SHOW_ELEMENT)
    let currentNode: Node | null = treeWalker.nextNode()
    while (currentNode) {
      if (
        currentNode instanceof Element &&
        (!currentNode.textContent || !currentNode.textContent.trim())
      ) {
        currentNode.remove()
      }
      currentNode = treeWalker.nextNode()
    }
  }
  removeEmptyElements(tempDiv)
  const text = tempDiv.textContent || tempDiv.innerText || ''
  return text.replace(/\s+/g, ' ').trim()
}

export const isCompanyDisabled = (company: any) => {
  switch (company.plans[0].subscription.type) {
    case 'enterprise':
      return true
    case 'free':
      if (!company.is_expired && !company.is_active) {
        return true
      }
      break
    case 'paid':
      if (!company.is_expired && company.plans[0].payment_status === 'paid' && !company.is_active) {
        return true
      }
      break
    default:
      return false
  }
  return false
}

export const isUserRoleDisabled = (company: any) => {
  if (company?.groups && company?.groups.length > 0) {
    return company?.groups?.some((item: any) => item.slug === 'company-admins')
  }
  return true
}

export const isUserInactive = (company: any) => {
  if (company?.users_groups && company?.users_groups.length > 0) {
    return company?.users_groups?.every((item: any) => item.is_active === false)
  }
  return false
}

export const paymentLink = (link: string, reference_id?: string) => {
  const state = store.getState() as RootState
  const billingDetails: any = state.common.billingDetails

  const billingEmail =
    billingDetails && billingDetails.billing_email ? billingDetails.billing_email : null

  let baseUrl = link
  const params: string[] = []

  if (billingEmail) {
    params.push(`prefilled_email=${billingEmail}`)
  }

  if (reference_id) {
    params.push(`client_reference_id=${reference_id}`)
  }

  if (params.length > 0) {
    baseUrl = `${link}?${params.join('&')}`
  }

  return baseUrl
}

export const requiredKeys = {
  root: ['name'],
  section: ['name', 'description'],
  formData: [
    'type',
    'label',
    'required',
    'comment_required',
    'image_required',
    'action_required',
    'is_new_row',
    'min_length',
    'max_length',
    'placeholder',
    'name',
    'default_value',
    'notes',
    'grid',
    'is_options_available',
    'is_placeholder_required',
    'is_single_option',
    'options',
  ],
}

export const validateKeys = (obj: any, requiredKeys: string[]) => {
  const missingKeys = requiredKeys.filter((key) => !(key in obj))
  return missingKeys.length === 0 ? null : missingKeys
}

export const ALLOWED_FORM_TYPES = ['dropDown', 'textBox', 'textArea', 'checkBox', 'radioButton']

export const FIELD_CONSTRAINTS = {
  grid: { max: 12, min: 0 },
  min_length: { min: 0 },
  max_length: { min: 0 },
}

export const validateJson = (jsonData: any, setImportError: any): boolean => {
  const rootValidation = validateKeys(jsonData, requiredKeys.root)
  if (rootValidation) {
    setImportError(`Missing root keys: ${rootValidation.join(', ')}`)
    return false
  }

  if ('id' in jsonData) {
    const id = jsonData.id
    if (typeof id !== 'string') {
      setImportError('id must be an unique string value')
      return false
    }
  }

  if ('description' in jsonData && typeof jsonData.description !== 'string') {
    setImportError('Description must be a string value')
    return false
  }

  if (Array.isArray(jsonData.sections) && jsonData.sections.length > 0) {
    for (const section of jsonData.sections) {
      const sectionValidation = validateKeys(section, requiredKeys.section)
      if (sectionValidation) {
        setImportError(`Missing required section keys: ${sectionValidation.join(', ')}`)
        return false
      }

      if (typeof section.name !== 'string') {
        setImportError('Section name must be a string')
        return false
      }
      if (typeof section.description !== 'string') {
        setImportError('Section description must be a string')
        return false
      }

      if ('dragged_section_position' in section) {
        const position = section.dragged_section_position
        if (typeof position !== 'number' || !Number.isInteger(position)) {
          setImportError('dragged_section_position must be a number')
          return false
        }
      }

      if (Array.isArray(section.form_data) && section.form_data.length > 0) {
        for (const formItem of section.form_data) {
          const formDataValidation = validateKeys(formItem, requiredKeys.formData)
          if (formDataValidation) {
            setImportError(`Missing required form data keys: ${formDataValidation.join(', ')}`)
            return false
          }

          if (!ALLOWED_FORM_TYPES.includes(formItem.type)) {
            setImportError(
              `Invalid form type: ${formItem.type}. Allowed types are: ${ALLOWED_FORM_TYPES.join(', ')}`
            )
            return false
          }

          const numericFields = ['grid', 'min_length', 'max_length']
          for (const field of numericFields) {
            if (typeof formItem[field] === 'string') {
              formItem[field] = Number(formItem[field])
            }
          }

          if (
            typeof formItem.grid !== 'number' ||
            formItem.grid < FIELD_CONSTRAINTS.grid.min ||
            formItem.grid > FIELD_CONSTRAINTS.grid.max
          ) {
            setImportError(
              `Grid must be a number between ${FIELD_CONSTRAINTS.grid.min} and ${FIELD_CONSTRAINTS.grid.max}`
            )
            return false
          }

          if (
            typeof formItem.min_length !== 'number' ||
            formItem.min_length < FIELD_CONSTRAINTS.min_length.min
          ) {
            setImportError(
              `min_length must be a number greater than or equal to ${FIELD_CONSTRAINTS.min_length.min}`
            )
            return false
          }

          if (
            typeof formItem.max_length !== 'number' ||
            formItem.max_length < FIELD_CONSTRAINTS.max_length.min
          ) {
            setImportError(
              `max_length must be a number greater than or equal to ${FIELD_CONSTRAINTS.max_length.min}`
            )
            return false
          }

          const booleanFields = [
            'required',
            'comment_required',
            'image_required',
            'action_required',
            'is_new_row',
            'is_options_available',
            'is_placeholder_required',
            'is_single_option',
          ]
          for (const field of booleanFields) {
            if (typeof formItem[field] !== 'boolean') {
              setImportError(`${field} must be a boolean value`)
              return false
            }
          }

          const stringFields = ['label', 'placeholder', 'name', 'default_value', 'notes']
          for (const field of stringFields) {
            if (typeof formItem[field] !== 'string') {
              setImportError(`${field} must be a string value`)
              return false
            }
          }
          if (formItem.is_options_available) {
            for (const opt of formItem.options) {
              if ('option' in opt && typeof opt.option !== 'string') {
                setImportError('Option key must be a string if provided')
                return false
              }
              if ('key' in opt && typeof opt.key !== 'string') {
                setImportError('Option key must be a string if provided')
                return false
              }
              if ('value' in opt && typeof opt.value !== 'string') {
                setImportError('Option value must be a string if provided')
                return false
              }
            }
          }
        }
      }
    }
  }

  return true
}

export const simulateUploadProgress = (setUploadProgress: any) => {
  let progress = 0
  const interval = setInterval(() => {
    progress += 10
    setUploadProgress(progress)
    if (progress >= 100) clearInterval(interval)
  }, 300)
}

export const removeUnwantedKeys = (obj: any) => {
  const keysToRemove = [
    'is_active',
    'created_at',
    'deleted_at',
    'inspection_company',
    'pdf_url',
    'updated_at',
    'status',
    'sections_merged_form_data',
    'template_type',
    'template_categories',
    'stripe_payment_link',
    'stripe_product_id',
    'template_plan_type',
    'template_price',
    'currency',
    'purchases',
  ]

  const filteredObject = Object.keys(obj).reduce((acc, key) => {
    if (!keysToRemove.includes(key)) {
      acc[key] = obj[key]
    }
    return acc
  }, {} as any)

  if (filteredObject.form_data && typeof filteredObject.form_data === 'string') {
    try {
      filteredObject.form_data = JSON.parse(filteredObject.form_data)
    } catch (e) {
      console.error('Error parsing form_data:', e)
    }
  }

  if (filteredObject.form_data && Array.isArray(filteredObject.form_data)) {
    filteredObject.form_data = filteredObject.form_data.map((item: any) => {
      const { uuid, ...rest } = item
      return rest
    })
  }

  if (filteredObject.sections) {
    filteredObject.sections = filteredObject.sections.map((section: any) =>
      removeUnwantedKeys(section)
    )
  }

  return filteredObject
}

export const sortWeekdays = (weekdays: string[]): string => {
  const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
  return weekdays
    .filter((day) => dayOrder.includes(day))
    .sort((a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b))
    .join(', ')
}

export const sortWeekdaysArray = (weekdays: string[]): string[] => {
  const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
  return weekdays
    .filter((day) => dayOrder.includes(day))
    .sort((a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b))
}

export const formatTimeDisplay = (timeString: string) => {
  return moment(timeString, 'HH:mm').format('hh:mm A')
}

export const getStatusColor = (status: string) => {
  switch (status.toLowerCase()) {
    case 'rescheduled':
      return 'warning'
    case 'approved':
      return 'success'
    case 'rejected':
      return 'danger'
    default:
      return 'primary'
  }
}

type CountryRule = (nationalNumber: string) => boolean
type CountryRules = Record<string, CountryRule>

export const countrySpecificRules: CountryRules = {
  // North America
  '1': (n) => /^[2-9]\d{2}[2-9]\d{6}$/.test(n), // USA/Canada
  '1242': (n) => /^\d{7}$/.test(n), // Bahamas
  '1246': (n) => /^\d{7}$/.test(n), // Barbados
  '1264': (n) => /^\d{7}$/.test(n), // Anguilla
  '1268': (n) => /^\d{7}$/.test(n), // Antigua & Barbuda
  '1284': (n) => /^\d{7}$/.test(n), // British Virgin Islands
  '1340': (n) => /^\d{7}$/.test(n), // US Virgin Islands
  '1441': (n) => /^\d{7}$/.test(n), // Bermuda
  '1473': (n) => /^\d{7}$/.test(n), // Grenada
  '1649': (n) => /^\d{7}$/.test(n), // Turks & Caicos
  '1658': (n) => /^[2-9]\d{6}$/.test(n), // Jamaica
  '1664': (n) => /^\d{7}$/.test(n), // Montserrat
  '1670': (n) => /^\d{7}$/.test(n), // Northern Mariana Islands
  '1671': (n) => /^\d{7}$/.test(n), // Guam
  '1758': (n) => /^\d{7}$/.test(n), // Saint Lucia
  '1767': (n) => /^\d{7}$/.test(n), // Dominica
  '1784': (n) => /^\d{7}$/.test(n), // Saint Vincent & Grenadines
  '1809': (n) => /^\d{7}$/.test(n), // Dominican Republic
  '1868': (n) => /^\d{7}$/.test(n), // Trinidad & Tobago
  '1869': (n) => /^\d{7}$/.test(n), // Saint Kitts & Nevis
  '1876': (n) => /^\d{7}$/.test(n), // Jamaica
  '1939': (n) => /^\d{7}$/.test(n), // Puerto Rico

  // Europe
  '30': (n) => /^69\d{8}$/.test(n), // Greece
  '31': (n) => /^6\d{8}$/.test(n), // Netherlands
  '32': (n) => /^[4-9]\d{7,8}$/.test(n), // Belgium
  '33': (n) => /^[67]\d{8}$/.test(n), // France
  '34': (n) => /^[67]\d{8}$/.test(n), // Spain
  '36': (n) => /^[2-9]\d{7,8}$/.test(n), // Hungary
  '39': (n) => /^3\d{8,9}$/.test(n), // Italy
  '40': (n) => /^7\d{8}$/.test(n), // Romania
  '41': (n) => /^[7-9]\d{8}$/.test(n), // Switzerland
  '43': (n) => /^6\d{3,10}$/.test(n), // Austria
  '44': (n) => /^7\d{9}$/.test(n), // UK
  '45': (n) => /^[2-9]\d{7}$/.test(n), // Denmark
  '46': (n) => /^7\d{8}$/.test(n), // Sweden
  '47': (n) => /^[49]\d{7}$/.test(n), // Norway
  '48': (n) => /^[5-8]\d{8}$/.test(n), // Poland
  '49': (n) => /^1[5-7]\d{8,9}$/.test(n), // Germany

  // Asia
  '60': (n) => /^1\d{8,9}$/.test(n), // Malaysia
  '61': (n) => /^4\d{8}$/.test(n), // Australia
  '62': (n) => /^8\d{9,11}$/.test(n), // Indonesia
  '63': (n) => /^9\d{9}$/.test(n), // Philippines
  '64': (n) => /^[2]\d{7,9}$/.test(n), // New Zealand
  '65': (n) => /^[89]\d{7}$/.test(n), // Singapore
  '66': (n) => /^[689]\d{8}$/.test(n), // Thailand
  '81': (n) => /^(70|80|90)\d{8}$/.test(n), // Japan
  '82': (n) => /^1\d{8,9}$/.test(n), // South Korea
  '84': (n) => /^[3-9]\d{7,8}$/.test(n), // Vietnam
  '86': (n) => /^1[3-9]\d{9}$/.test(n), // China
  '90': (n) => /^5\d{9}$/.test(n), // Turkey
  '91': (n) => /^[6-9]\d{9}$/.test(n), // India
  '92': (n) => /^3\d{9}$/.test(n), // Pakistan
  '93': (n) => /^7\d{8}$/.test(n), // Afghanistan
  '94': (n) => /^7\d{8}$/.test(n), // Sri Lanka
  '95': (n) => /^9\d{8}$/.test(n), // Myanmar
  '98': (n) => /^9\d{9}$/.test(n), // Iran

  // Africa
  '20': (n) => /^1[0-25]\d{8}$/.test(n), // Egypt
  '212': (n) => /^[6-7]\d{8}$/.test(n), // Morocco
  '213': (n) => /^[5-7]\d{8}$/.test(n), // Algeria
  '216': (n) => /^[259]\d{7}$/.test(n), // Tunisia
  '234': (n) => /^[7-9]\d{9}$/.test(n), // Nigeria
  '254': (n) => /^7\d{8}$/.test(n), // Kenya
  '255': (n) => /^[67]\d{8}$/.test(n), // Tanzania
  '256': (n) => /^7\d{8}$/.test(n), // Uganda
  '257': (n) => /^[79]\d{7}$/.test(n), // Burundi
  '258': (n) => /^8[2-8]\d{7}$/.test(n), // Mozambique
  '260': (n) => /^9[567]\d{7}$/.test(n), // Zambia
  '261': (n) => /^[32-34]\d{7}$/.test(n), // Madagascar
  '262': (n) => /^6\d{8}$/.test(n), // Réunion
  '263': (n) => /^7\d{8}$/.test(n), // Zimbabwe
  '264': (n) => /^[678]\d{7}$/.test(n), // Namibia
  '265': (n) => /^[1789]\d{7,8}$/.test(n), // Malawi
  '266': (n) => /^[5-8]\d{7}$/.test(n), // Lesotho
  '267': (n) => /^7[1-8]\d{6}$/.test(n), // Botswana
  '268': (n) => /^[76]\d{7}$/.test(n), // Eswatini
  '269': (n) => /^3\d{6}$/.test(n), // Comoros
  '27': (n) => /^[6-8]\d{8}$/.test(n), // South Africa

  // Middle East
  '351': (n) => /^9\d{8}$/.test(n), // Portugal
  '352': (n) => /^6\d{8}$/.test(n), // Luxembourg
  '353': (n) => /^8\d{8}$/.test(n), // Ireland
  '354': (n) => /^\d{7}$/.test(n), // Iceland
  '355': (n) => /^6[6-9]\d{6}$/.test(n), // Albania
  '356': (n) => /^[79]\d{7}$/.test(n), // Malta
  '357': (n) => /^9\d{7}$/.test(n), // Cyprus
  '358': (n) => /^4\d{8}$/.test(n), // Finland
  '359': (n) => /^[78]\d{8}$/.test(n), // Bulgaria
  '370': (n) => /^6\d{7}$/.test(n), // Lithuania
  '371': (n) => /^2\d{7}$/.test(n), // Latvia
  '372': (n) => /^[5-9]\d{7}$/.test(n), // Estonia
  '373': (n) => /^[67]\d{7}$/.test(n), // Moldova
  '374': (n) => /^[4-9]\d{7}$/.test(n), // Armenia
  '375': (n) => /^[2-49]\d{8}$/.test(n), // Belarus
  '376': (n) => /^[36]\d{7}$/.test(n), // Andorra
  '377': (n) => /^[46]\d{7}$/.test(n), // Monaco
  '378': (n) => /^6\d{8}$/.test(n), // San Marino
  '380': (n) => /^[3-9]\d{8}$/.test(n), // Ukraine
  '381': (n) => /^6\d{7,8}$/.test(n), // Serbia
  '382': (n) => /^6\d{7}$/.test(n), // Montenegro
  '383': (n) => /^4\d{7}$/.test(n), // Kosovo
  '385': (n) => /^9\d{8}$/.test(n), // Croatia
  '386': (n) => /^[3-7]\d{7}$/.test(n), // Slovenia
  '387': (n) => /^6\d{7}$/.test(n), // Bosnia & Herzegovina
  '389': (n) => /^7\d{7}$/.test(n), // North Macedonia
  '420': (n) => /^7\d{8}$/.test(n), // Czech Republic
  '421': (n) => /^9\d{8}$/.test(n), // Slovakia
  '423': (n) => /^[67]\d{7}$/.test(n), // Liechtenstein

  // Other regions
  '500': (n) => /^\d{5}$/.test(n), // Falkland Islands
  '501': (n) => /^[6-7]\d{6}$/.test(n), // Belize
  '502': (n) => /^[4-7]\d{7}$/.test(n), // Guatemala
  '503': (n) => /^[67]\d{7}$/.test(n), // El Salvador
  '504': (n) => /^[389]\d{7}$/.test(n), // Honduras
  '505': (n) => /^[578]\d{7}$/.test(n), // Nicaragua
  '506': (n) => /^[5-8]\d{7}$/.test(n), // Costa Rica
  '507': (n) => /^[6-8]\d{7}$/.test(n), // Panama
  '508': (n) => /^\d{6}$/.test(n), // Saint Pierre & Miquelon
  '509': (n) => /^[34]\d{7}$/.test(n), // Haiti
  '590': (n) => /^6\d{8}$/.test(n), // Guadeloupe
  '591': (n) => /^[67]\d{7}$/.test(n), // Bolivia
  '592': (n) => /^6\d{6}$/.test(n), // Guyana
  '593': (n) => /^9\d{8}$/.test(n), // Ecuador
  '594': (n) => /^6\d{8}$/.test(n), // French Guiana
  '595': (n) => /^9\d{8}$/.test(n), // Paraguay
  '596': (n) => /^6\d{8}$/.test(n), // Martinique
  '597': (n) => /^[6-8]\d{6}$/.test(n), // Suriname
  '598': (n) => /^9\d{7}$/.test(n), // Uruguay
  '599': (n) => /^9\d{7}$/.test(n), // Curaçao
  '670': (n) => /^7\d{7}$/.test(n), // Timor-Leste
  '672': (n) => /^\d{5}$/.test(n), // Australian External Territories
  '673': (n) => /^[2-9]\d{6}$/.test(n), // Brunei
  '674': (n) => /^[4589]\d{6}$/.test(n), // Nauru
  '675': (n) => /^7\d{7}$/.test(n), // Papua New Guinea
  '676': (n) => /^\d{7}$/.test(n), // Tonga
  '677': (n) => /^[7-9]\d{6}$/.test(n), // Solomon Islands
  '678': (n) => /^[579]\d{6}$/.test(n), // Vanuatu
  '679': (n) => /^7\d{7}$/.test(n), // Fiji
  '680': (n) => /^\d{7}$/.test(n), // Palau
  '681': (n) => /^\d{6}$/.test(n), // Wallis & Futuna
  '682': (n) => /^\d{5}$/.test(n), // Cook Islands
  '683': (n) => /^\d{4}$/.test(n), // Niue
  '685': (n) => /^\d{6}$/.test(n), // Samoa
  '686': (n) => /^\d{8}$/.test(n), // Kiribati
  '687': (n) => /^\d{6}$/.test(n), // New Caledonia
  '688': (n) => /^\d{5}$/.test(n), // Tuvalu
  '689': (n) => /^\d{8}$/.test(n), // French Polynesia
  '690': (n) => /^\d{4}$/.test(n), // Tokelau
  '691': (n) => /^\d{7}$/.test(n), // Micronesia
  '692': (n) => /^\d{7}$/.test(n), // Marshall Islands
  '850': (n) => /^19\d{7}$/.test(n), // North Korea
  '852': (n) => /^[569]\d{7}$/.test(n), // Hong Kong
  '853': (n) => /^6\d{7}$/.test(n), // Macau
  '855': (n) => /^[1-9]\d{7}$/.test(n), // Cambodia
  '856': (n) => /^20\d{7}$/.test(n), // Laos
  '880': (n) => /^1[5-9]\d{8}$/.test(n), // Bangladesh
  '886': (n) => /^9\d{8}$/.test(n), // Taiwan
  '960': (n) => /^[7-9]\d{6}$/.test(n), // Maldives
  '961': (n) => /^[37-9]\d{6}$/.test(n), // Lebanon
  '962': (n) => /^7\d{8}$/.test(n), // Jordan
  '963': (n) => /^9\d{8}$/.test(n), // Syria
  '964': (n) => /^7\d{9}$/.test(n), // Iraq
  '965': (n) => /^[569]\d{7}$/.test(n), // Kuwait
  '966': (n) => /^5\d{8}$/.test(n), // Saudi Arabia
  '967': (n) => /^7\d{8}$/.test(n), // Yemen
  '968': (n) => /^9\d{7}$/.test(n), // Oman
  '970': (n) => /^5\d{7}$/.test(n), // Palestine
  '971': (n) => /^5\d{8}$/.test(n), // UAE
  '972': (n) => /^5\d{8}$/.test(n), // Israel
  '973': (n) => /^[3-9]\d{7}$/.test(n), // Bahrain
  '974': (n) => /^[3-7]\d{7}$/.test(n), // Qatar
  '975': (n) => /^[17]\d{7}$/.test(n), // Bhutan
  '976': (n) => /^[5-9]\d{7}$/.test(n), // Mongolia
  '977': (n) => /^9\d{8}$/.test(n), // Nepal
  '992': (n) => /^9\d{8}$/.test(n), // Tajikistan
  '993': (n) => /^6\d{7}$/.test(n), // Turkmenistan
  '994': (n) => /^[4-9]\d{8}$/.test(n), // Azerbaijan
  '995': (n) => /^5\d{8}$/.test(n), // Georgia
  '996': (n) => /^[5-7]\d{8}$/.test(n), // Kyrgyzstan
  '998': (n) => /^[679]\d{8}$/.test(n), // Uzbekistan
}

export function validatePhoneField(value: string, country_code: string): boolean {
  // Clean the input value
  const cleanedValue = value.replace(/\D/g, '')
  const fullPhone = `+${country_code}${cleanedValue}`

  // Parse the phone number
  const phoneNumber = parsePhoneNumberFromString(fullPhone)

  // Basic validation check
  if (!phoneNumber || !phoneNumber.isValid()) {
    return false
  }

  // Apply country-specific rules if they exist
  const countryRule = countrySpecificRules[country_code]
  if (countryRule) {
    const countrySpecificValid = countryRule(phoneNumber.nationalNumber)
    if (countrySpecificValid) {
      return true
    } else {
      return false
    }
  }

  return true
}

export const validatePhoneNumber = (phoneNumber: string, countryCode: string) => {
  const phoneRegex = /^\d{8,}$/
  if (!phoneNumber) {
    return true
  } else if (!phoneRegex.test(phoneNumber)) {
    return true
  }
  return !validatePhoneField(phoneNumber, countryCode)
}

export const extractSignificantFiltersFromQuery = (query: string): string => {
  return query
    .split('&')
    .filter(
      (q) => !q.startsWith('page=') && !q.startsWith('items_per_page=') && !q.startsWith('id=')
    )
    .sort()
    .join('&')
}

export const FILE_SIZE = 5 * 1024 * 1024
export const SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/x-icon',
  'image/svg+xml',
  'image/svg',
]

const BLOCK_ELEMENTS_EDITOR_CONFIGURATION = new Set(['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'])

export const mergeTrailingTextForCKEditor = (htmlString: string): string => {
  const regex = /([\s\S]*<\/([^>\s]+)>)([^<>\n\r]*)$/
  const match = htmlString.match(regex)

  if (match) {
    const before = match[1]
    const lastTag = match[2].toLowerCase()
    let trailing = match[3].trim()

    if (BLOCK_ELEMENTS_EDITOR_CONFIGURATION.has(lastTag) && trailing) {
      if (!trailing.startsWith(' ')) {
        trailing = ' ' + trailing
      }
      return before.replace(/(<\/[^>]+>)$/, `${trailing}$1`)
    }
    return htmlString
  }
  return htmlString
}

export const getTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone

export function getFrequencyLink(
  contextType: 'site' | 'asset' | 'schedule',
  asset_id: ID,
  site_id: ID,
  frequency_id: ID,
  actionType: 'show' | 'edit'
): string {
  if (contextType === 'schedule') {
    return `/schedule/${asset_id}/event-planner/${frequency_id}/${actionType}`
  } else if (contextType === 'site') {
    return `/sites/${asset_id}/${site_id}/event-planner/${frequency_id}/${actionType}`
  } else {
    return `/assets/${asset_id}/event-planner/${frequency_id}/${actionType}`
  }
}

export function getCreateFrequencyLink(
  contextType: 'site' | 'asset' | 'schedule',
  asset_id: ID,
  site_id?: ID
): string {
  if (contextType === 'schedule') {
    return `/schedule/${asset_id}/event-planner/create`
  } else if (contextType === 'site' && site_id) {
    return `/sites/${asset_id}/${site_id}/event-planner/create`
  } else {
    return `/assets/${asset_id}/event-planner/create`
  }
}

export function isValidLatitude(value: any) {
  const num = Number(value)
  return !isNaN(num) && num >= -90 && num <= 90
}

export function isValidLongitude(val: any) {
  const num = Number(val)
  return !isNaN(num) && num >= -180 && num <= 180
}

export const templateTypes = [
  { value: 'free', label: 'Free' },
  { value: 'paid', label: 'Paid' },
]

export const findPaidPurchase = (purchases: any[]): any => {
  if (!Array.isArray(purchases) || purchases.length === 0) {
    return null
  }
  return (
    purchases.find(
      (purchase: any) =>
        purchase?.payment_status && purchase.payment_status.toLowerCase() === 'paid'
    ) || null
  )
}

export const findInspectionCompanyById = (companyId: string, inspectionCompanies: any[]): any => {
  if (!companyId || !Array.isArray(inspectionCompanies) || inspectionCompanies.length === 0) {
    return null
  }
  return inspectionCompanies.find((company: any) => company.id === companyId) || null
}

export const canUnarchive = (activeCount: number, limit: number): boolean => {
  return activeCount < limit
}

export const getSubscriptionLimits = (dashboardAnalytics: any) => {
  return {
    projects: dashboardAnalytics?.subscriptionPlan?.allowed_projects || 0,
    sites: dashboardAnalytics?.subscriptionPlan?.allowed_sites || 0,
    assets: dashboardAnalytics?.subscriptionPlan?.allowed_assets || 0,
    users: dashboardAnalytics?.subscriptionPlan?.allowed_users || 0,
  }
}

export const getActiveCounts = (dashboardAnalytics: any) => {
  return {
    projects: dashboardAnalytics?.activeStatistics?.projects || 0,
    sites: dashboardAnalytics?.activeStatistics?.sites || 0,
    assets: dashboardAnalytics?.activeStatistics?.assets || 0,
    users: dashboardAnalytics?.activeStatistics?.users || 0,
  }
}

export const getLimitReachedMessage = (moduleType: 'Project' | 'Site' | 'Asset'): string => {
  const moduleName = moduleType.toLowerCase()
  return `You've reached the maximum number of active ${moduleName}s allowed in your plan. Please archive or delete an existing active ${moduleName} to create a new one.`
}

export function getSeatsPurchaseName(number_of_seats: number): string {
  return `${number_of_seats} Additional Seat${number_of_seats > 1 ? 's' : ''} Purchased`
}

export const GetCurrentActivePlan = (isArrivedFromTheAccessDeniedPage: boolean = false) => {
  const { active_inspection_company, expired_inspection_company }: any = useSelector<RootState>(
    (state) => ({
      active_inspection_company: state.auth.active_inspection_company,
      expired_inspection_company: state.auth.expired_inspection_company,
    }),
    shallowEqual
  )

  return isArrivedFromTheAccessDeniedPage
    ? expired_inspection_company?.plans?.[0]
    : active_inspection_company?.plans?.[0]
}

export const IsCurrentPlanFree = (isArrivedFromTheAccessDeniedPage: boolean = false) => {
  const currentPlan = GetCurrentActivePlan(isArrivedFromTheAccessDeniedPage)
  return currentPlan && currentPlan.subscription && currentPlan.subscription.type === 'free'
}

export const IsPlanCancelled = () => {
  const currentPlan = GetCurrentActivePlan()
  return currentPlan?.is_cancelled || false
}

export const IsCancelledPaidPlan = () => {
  const currentPlan = GetCurrentActivePlan()
  const isCancelled = currentPlan?.is_cancelled || false
  const isPaid = currentPlan?.subscription?.type !== 'free'
  return isCancelled && isPaid
}

export const formatDaysRemaining = (days: number): string => {
  return days === 1 ? '1 day' : `${days} days`
}

export const checkUpgradePaymentRequired = (
  selectedCompany: any
): { required: boolean; link: string | null } => {
  if (selectedCompany?.upgrade_requests && Array.isArray(selectedCompany.upgrade_requests)) {
    const upgradeRequest = selectedCompany.upgrade_requests.find(
      (request: any) =>
        request.is_upgrade_payment_required === true &&
        request.payment_status === 'pending' &&
        request.upgrade_payment_link &&
        request.upgrade_payment_link.trim() !== ''
    )

    if (upgradeRequest) {
      return {
        required: true,
        link: upgradeRequest.upgrade_payment_link,
      }
    }
  }

  return { required: false, link: null }
}

export const isCompanyGracePeriodExpired = (selectedCompany: any): boolean => {
  if (!selectedCompany) {
    return false
  }
  const { grace_period_status } = selectedCompany
  return grace_period_status === 'grace_period_ended'
}

export const isCompanyInTheGracePeriod = (selectedCompany: any): boolean => {
  if (!selectedCompany) {
    return false
  }
  const { grace_period_status } = selectedCompany
  return grace_period_status === 'in_grace_period'
}

export const isCurrentPlanLimitHigher = (dashboardAnalytics: any, planToCompare: any): boolean => {
  if (!dashboardAnalytics || !dashboardAnalytics.activeStatistics) {
    return false
  }

  if (dashboardAnalytics.length > 0) {
    return false
  }
  if (planToCompare?.type === 'enterprise') {
    return false
  }

  const currentLimits = dashboardAnalytics.activeStatistics

  const comparedLimits = {
    projects: planToCompare?.number_of_active_inspection_projects || 0,
    sites: planToCompare?.number_of_active_inspection_sites || 0,
    assets: planToCompare?.number_of_active_inspection_assets || 0,
  }

  return (
    currentLimits.projects > comparedLimits.projects ||
    currentLimits.sites > comparedLimits.sites ||
    currentLimits.assets > comparedLimits.assets
  )
}

export const clearUserFormDataFromSession = () => {
  sessionStorage.removeItem('teamMemberFormData')
}

export const filterByDeletedStatus = <T extends { deleted_at: string | null }>(
  items: T[],
  includeDeleted: boolean = false
): T[] => {
  if (!Array.isArray(items)) {
    return []
  }

  return items.filter((item) =>
    includeDeleted ? item.deleted_at !== null : item.deleted_at === null
  )
}

export const openFileInNewTab = (fileUrl: string) => {
  window.open(fileUrl, '_blank', 'noopener,noreferrer')
}

export const downloadFile = (fileUrl: string, fileName?: string) => {
  const link = document.createElement('a')
  link.href = fileUrl
  if (fileName) {
    link.download = fileName
  } else {
    const urlParts = fileUrl.split('/')
    const extractedFileName = urlParts[urlParts.length - 1] || 'download'
    link.download = extractedFileName
  }
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const isImageFile = (url: string): boolean => {
  if (!url) return false
  const imageExtensions = [
    '.jpg',
    '.jpeg',
    '.png',
    '.gif',
    '.webp',
    '.heic',
    '.heif',
    '.heics',
    '.heifs',
    '.jpe',
    '.jfif',
    '.jif',
  ]
  const cleanUrl = url.split('?')[0].toLowerCase()
  return imageExtensions.some((ext) => cleanUrl.endsWith(ext))
}

export const getFileType = (url: string): string => {
  if (!url) return 'unknown'
  const cleanUrl = url.split('?')[0].toLowerCase()

  // Images
  if (/\.(jpg|jpeg|png|gif|webp)$/i.test(cleanUrl)) return 'Image'
  if (/\.(heic|heif)$/i.test(cleanUrl)) return 'HEIC'

  // PDF
  if (/\.pdf$/i.test(cleanUrl)) return 'PDF'

  // Video
  if (/\.(mp4|webm|mov|avi|mkv)$/i.test(cleanUrl)) return 'Video'

  // Audio
  if (/\.(mp3|wav|ogg|aac)$/i.test(cleanUrl)) return 'Audio'

  // Office Documents
  if (/\.(doc|docx)$/i.test(cleanUrl)) return 'Word'
  if (/\.(xls|xlsx)$/i.test(cleanUrl)) return 'Excel'
  if (/\.(ppt|pptx)$/i.test(cleanUrl)) return 'PowerPoint'

  // Text / CSV
  if (/\.csv$/i.test(cleanUrl)) return 'CSV'
  if (/\.txt$/i.test(cleanUrl)) return 'Text'

  return 'File'
}


export const shouldOpenInNewTab = (fileType: string): boolean => {
  return ['PDF', 'CSV', 'Text', 'Video'].includes(fileType)
}

export const shouldRenderInline = (fileType: string): boolean => {
  return ['Image', 'Audio', 'HEIC'].includes(fileType)
}

export const shouldDownload = (fileType: string): boolean => {
  return ['Word', 'Excel', 'PowerPoint', 'File'].includes(fileType)
}